import React, { memo } from 'react';
import { EdgeProps, getBezierPath, EdgeLabelRenderer, BaseEdge } from '@xyflow/react';

export type EdgeType = 'dialog_flow' | 'relationship' | 'custom';

interface CustomEdgeData {
  label?: string;
  type?: EdgeType;
}

export const CustomEdge = memo(({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  markerEnd,
  selected,
}: EdgeProps<CustomEdgeData>) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const edgeType = data?.type || 'custom';
  
  // Define styles based on edge type
  const getEdgeStyle = () => {
    switch (edgeType) {
      case 'dialog_flow':
        return {
          stroke: selected ? '#8b5cf6' : '#6366f1',
          strokeWidth: selected ? 3 : 2,
          strokeDasharray: 'none',
        };
      case 'relationship':
        return {
          stroke: selected ? '#10b981' : '#059669',
          strokeWidth: selected ? 3 : 2,
          strokeDasharray: '5,5',
        };
      case 'custom':
        return {
          stroke: selected ? '#f59e0b' : '#d97706',
          strokeWidth: selected ? 3 : 2,
          strokeDasharray: '2,4',
        };
      default:
        return {
          stroke: selected ? '#6b7280' : '#9ca3af',
          strokeWidth: selected ? 3 : 2,
          strokeDasharray: 'none',
        };
    }
  };

  const edgeStyle = getEdgeStyle();

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={edgeStyle}
      />
      {data?.label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'all',
            }}
            className="nodrag nopan"
          >
            <div 
              className={`
                px-2 py-1 rounded text-xs font-medium shadow-md
                ${selected ? 'ring-2 ring-primary ring-opacity-50' : ''}
              `}
              style={{
                backgroundColor: edgeStyle.stroke,
                color: 'white',
              }}
            >
              {data.label}
            </div>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
});

CustomEdge.displayName = 'CustomEdge';

